import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import SideBar from './SideBar';
import OnboardingProvider from 'onboarding/OnboardingProvider';
import './style.css';
var AppLayout = function (_a) {
    var appContent = _a.appContent;
    var _b = useState(false), collapsed = _b[0], setCollapsed = _b[1];
    return (_jsx(OnboardingProvider, { children: _jsxs("div", { className: "clinical-shell ".concat(collapsed ? 'clinical-shell--collapsed' : ''), role: "main", children: [_jsx(SideBar, { collapsed: collapsed, setCollapsed: setCollapsed }), _jsx("section", { className: "clinical-main", children: _jsx("div", { className: "clinical-main__scroll", children: appContent }) })] }) }));
};
export default AppLayout;
